export class GenerateOrderExcel {
    clientName: string;
    clientId: number;
    countryISO: string
    ordersList: Order[]
}

export class Order {
    itemSKU: string;
    itemName: string;

}